import React from 'react';

export const RiskHeader = ({
  className,
  color,
  height,
  width
}: {
  className?: string;
  color?: string;
  height?: number;
  width?: number;
}) => (
  <svg
    width={width ?? 41}
    height={height ?? 41}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.7438 6.83989L35.6931 34.3858H5.79448L20.7438 6.83989Z"
      stroke={color ? color : '#5243aa'}
      strokeWidth="3"
    />
    <path
      d="M22.2437 17.6239C22.2437 16.7955 21.5721 16.1239 20.7437 16.1239C19.9152 16.1239 19.2437 16.7955 19.2437 17.6239H22.2437ZM19.2437 23.2259C19.2437 24.0543 19.9152 24.7259 20.7437 24.7259C21.5721 24.7259 22.2437 24.0543 22.2437 23.2259H19.2437ZM19.2437 17.6239V23.2259H22.2437V17.6239H19.2437Z"
      fill={color ? color : '#5243aa'}
    />
    <circle
      cx="20.7437"
      cy="28.5272"
      r="2.24503"
      fill={color ? color : '#5243aa'}
    />
  </svg>
);
